/**
 * @author Nihar<nihar.baishya@314ecorp.com>
 * @description React Hook useDeleteClaimActivityAction
 */
import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import api from 'client/index';
import AppEvents from '@veritable/common/utils/appEvents';
import QUERY_KEYS from 'app-constants/queryKeys';

/**
 * Mutate for delete claim activity action
 *
 */
interface IProps {
	model: ClaimRequest.IActivityTypeDeleteRequest;
}
const useDeleteClaimActivityAction = (): UseMutationResult<unknown, IAxiosError, IProps, unknown> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({ model }) => {
			const { data } = await api.ActivityTypeApi.deleteActivityType(model);
			return data;
		},
		onSuccess: (data) => {
			// is deleted key will be true if data is deleted completely
			AppEvents.publishApiSuccess(data?.isDeleted ? '' : "Claim Activity has been marked as 'inactive'.");
			setTimeout(() => {
				queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.claimActivityType] });
			});
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default useDeleteClaimActivityAction;
